import { useTranslation } from 'react-i18next';

export const I18 = ({ text: rawText }: { text: string }) => {
  const { t } = useTranslation();

  const text = t(rawText);
  const renderedText = text.split(/ ?(\*.*?\*)/g).map((k, kk) => {
    if (String(k)[0] === '*' && String(k)[k.length - 1] === '*') {
      return (
        <span key={kk} style={{ fontWeight: 'bold' }}>
          {k.replace(/\*/g, '')}
        </span>
      );
    } else {
      return k + ' ';
    }
  });

  return <>{renderedText}</>;
};
